import { useEffect, useState } from 'react';
import { useAuth } from 'react-oidc-context';
import { deleteRequestPrescription, getAllRequestData } from '../service';
import { ColumnData } from '../interface/interface';
import { Table } from '../components/Table';
import Loading from '../components/Loading';
import CustomModal from '../components/CustomModal';
import showToast from '../components/ToastComponent';

const PatientPrescriptionDeleteRequest = () => {
  const { user } = useAuth();
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const [id, setId] = useState<string>();
  const [render, setRender] = useState<number>(0);
  const [openModal, setModal] = useState<boolean>(false);

  const getData = () => {
    if (!user?.access_token) {
      return;
    }
    getAllRequestData(user.access_token)
      .then((res) => {
        setId(undefined);
        setData(res.data);
        setLoading(false);
      })
      .catch((err) => {
        setId(undefined);
        setLoading(false);
        console.error(err);
      });
  };

  const confirmDelete = () => {
    if (!id || !user?.access_token) {
      console.error('Id or access token not found');
      return;
    }

    deleteRequestPrescription(id, user.access_token)
      .then((res) => {
        setRender((prev) => prev + 1);
        setModal(false);
        if (res.status === 200) {
          showToast({
            message: res.data.message,
            type: 'success',
          });
        } else {
          showToast({
            message: res.data.message,
            type: 'warning',
          });
        }
      })
      .catch((err: any) => {
        console.error(err);
        setModal(false);
        showToast({
          message: 'Failed to delete prescription. Please try again later.',
          type: 'error',
        });
      });
  };

  useEffect(() => {
    if (!openModal) {
      setModal(false);
      setId(undefined);
    }
  }, [openModal]);

  const columns: Array<ColumnData> = [
    {
      key: 'requestBy',
      header: () => 'Patient Name',
      cell: (info) => info.getValue(),
    },
    {
      key: 'reason',
      header: () => 'Reason',
      cell: (info) => info.getValue(),
    },
    {
      key: 'prescriptionCode',
      header: () => 'Prescription Code',
      cell: (info) => info.getValue(),
    },
    {
      key: 'action',
      cell: (info) => (
        <div className="flex justify-around">
          <span
            className="text-green-500 cursor-pointer"
            onClick={() => {
              setId(info.row.original.id);
              setModal(true);
            }}
          >
            Approve
          </span>
        </div>
      ),
    },
  ];

  useEffect(() => {
    setModal(false);
    setLoading(true);
    getData();
  }, [render]);

  if (loading) {
    return <Loading />;
  }

  if (!data.length) {
    return <h4 className="text-center mt-5">No Request Raised Yet</h4>;
  }

  return (
    <>
      <div className="mx-5 my-5 p-5">
        <div className="px-4 sm:px-6 lg:px-8">
          <div className="sm:flex sm:items-center">
            <div className="sm:flex-auto">
              <h1 className="text-xl font-semibold leading-6 text-gray-900">
                Request For Prescription Delete
              </h1>
            </div>
          </div>
          <div className="mt-8 flow-root">
            <div className="-mx-4 -my-2 overflow-x-hidden overflow-y-hidden sm:-mx-6 lg:-mx-8 min-h-[600px]">
              <div className="inline-block min-w-full py-2 align-middle sm:px-6 lg:px-8">
                <div className="overflow-hidden sm:rounded-lg">
                  <Table
                    columns={columns}
                    data={data}
                    enableSorting={true}
                    enablePagination={true}
                    enableSearch={true}
                    search={undefined}
                    pagintation={undefined}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <CustomModal
        isOpen={openModal}
        onClose={() => setModal(false)}
        header={'Are you sure want delete prescription'}
        footer={
          <>
            <button
              className="mr-4 bg-primary-blue-500 text-white px-4 py-2 rounded"
              onClick={() => confirmDelete()}
            >
              Submit
            </button>
            <button
              className="bg-white border border-solid border-primary-blue-500 text-primary-blue-500 px-4 py-2 rounded"
              onClick={() => setModal(false)}
            >
              Cancel
            </button>
          </>
        }
        modalSize={'w-3/12'}
      >
        {''}
      </CustomModal>
    </>
  );
};

export default PatientPrescriptionDeleteRequest;
